module.exports = __webpack_public_path__ + "img/city_course.1a6c02aa.jpg";